/* Devil kiwi variant — horns + pointed tail. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderDevil(p: KiwiPalette) {
  return (
    <>
      {/* Horns */}
      <rect x="8" y="2" width="2" height="4" fill={p.accent} opacity={0.6} />
      <rect x="20" y="2" width="2" height="4" fill={p.accent} opacity={0.6} />
      <rect x="7" y="0" width="2" height="2" fill={p.accent} opacity={0.5} />
      <rect x="21" y="0" width="2" height="2" fill={p.accent} opacity={0.5} />
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />
      {/* Eye — mischievous */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="10" y="12" width="2" height="2" fill={p.pupil} />
      {/* Tail — pointed */}
      <path d="M24 20H26V22H24V20ZM26 18H28V20H26V18ZM28 16H30V18H28V16ZM30 14H32V18H30V14Z" fill={p.accent} opacity={0.5} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
